var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_header"},[_c('a',{attrs:{"href":"https://www.ftvnews.com.tw/"}},[_c('img',{attrs:{"src":require("../assets/whitelogo.png"),"alt":"ftvlogo"}})])])
}]

export { render, staticRenderFns }